<template>
  <div class="app-container">
    <div>
      <div>
        <label>{{ $t('inventory.updateInventory') }} </label>
      </div>
      <div style="margin-top: 10px;">
        <label class="instructionLabel">{{ $t('inventory.instruction') }} </label>
      </div>
      <el-select
        v-model="selectedStockLocationID"
        class="search-select"
        type="select"
        clearable
        :placeholder="$t('common.stockLocation')"
        style="margin-top: 10px;"
      >
        <el-option
          v-for="stockLocation in stockLocations"
          :key="stockLocation.id"
          :label="stockLocation.name"
          :value="stockLocation.id"
        />
      </el-select>
      <file-upload
        :upload-route="uploadRoute"
        :disabled="disabled"
        :append-entity-id="false"
        :show-file-list="false"
        :on-success="handleSuccess"
        style="margin-top: 10px;"
      />
    </div>
  </div>
</template>

<script>
import FileUpload from '@/components/DSE/FileUpload';

export default {
  name: 'Inventory',
  components: {
    FileUpload
  },
  data() {
    return {
      selectedStockLocationID: null
    };
  },
  computed: {
    disabled() {
      return this.selectedStockLocationID === null || this.selectedStockLocationID <= 0;
    },
    stockLocations() {
      return this.$store.getters['stockLocation/loadedItems'];
    },
    uploadRoute() {
      return `stockLocation/${this.selectedStockLocationID}/inventory`;
    }
  },
  created() {
    this.$store.dispatch('stockLocation/getItems');
  },
  methods: {
    handleSuccess() {
      this.$store.dispatch('notify/success', { message: this.$i18n.t('inventory.inventoryUpdated') });
    }
  }
};
</script>

<style lang="scss">
.instructionLabel {
  display: block;
  font-size: 12px !important;
  font-weight: normal;
}
</style>
